export const TOP_BAR_HEIGHT = '70px';
